import React from "react";
import { useAtom } from "jotai";
import { highContrastAtom } from "../jotai/atoms";
import { WHITELABEL_KEY } from "../globals";

// Simple wrapper component to pull in high contrast mode from Jotai state
// and apply it to the root element of the app.
export default function HighContrastWrapper({ children }: { children: React.ReactNode }) {
  const [highContrast] = useAtom(highContrastAtom);

  return (
    <div
      // data-theme attr can't be applied since Tailwind (annoyingly) applies default light theme styling
      // that overrides some of the custom docket styling
      {...(highContrast && WHITELABEL_KEY !== "nj" ? { "data-theme": "dark" } : {})}
    >
      {children}
    </div>
  );
}
